import { ListLayout, Toggle } from '@ingrid/luterkort-react';

import { Schema } from '../queries';

interface Props {
  schema: Schema;
  path?: string;
}

export function SchemaDisplayBoolean({ schema }: Props) {
  if (schema.type !== 'boolean') {
    return null;
  }

  return (
    <ListLayout.Stack>
      <ListLayout.SecondaryText>{schema.title}</ListLayout.SecondaryText>
      <Toggle checked={!!schema.value} aria-label={schema.title} disabled={true} />
    </ListLayout.Stack>
  );
}
